import React, { useState } from 'react';
import { Box, Typography, Paper, Button, Card, CardContent, CircularProgress } from '@mui/material';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from 'lib/firebase';

const AdvenchoreStoryPage = () => {
  const [user, loading] = useAuthState(auth);
  const [story, setStory] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const generateStory = async () => {
    if (!user) return;
    
    setIsGenerating(true);
    try {
      // Placeholder for story generation logic
      // This would typically call your Firebase function
      const newStory = {
        title: "Sample Adventure Story",
        content: "Once upon a time, in a land far away, there lived a brave adventurer who embarked on an epic quest...",
        createdAt: new Date().toISOString(),
        userId: user.uid
      };
      
      setStory(newStory);
    } catch (error) {
    } finally {
      setIsGenerating(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Please log in to view Advenchore Stories
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Advenchore Story Generator
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        Generate personalized adventure stories based on your chore completion and achievements!
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Button 
          variant="contained" 
          onClick={generateStory}
          disabled={isGenerating}
          sx={{ mr: 2 }}
        >
          {isGenerating ? 'Generating...' : 'Generate New Story'}
        </Button>
      </Box>

      {isGenerating && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ ml: 2, alignSelf: 'center' }}>
            Crafting your adventure...
          </Typography>
        </Box>
      )}

      {story && (
        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" component="h2" gutterBottom>
              {story.title}
            </Typography>
            <Typography variant="body1" paragraph>
              {story.content}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Generated on: {new Date(story.createdAt).toLocaleDateString()}
            </Typography>
          </CardContent>
        </Card>
      )}

      {!story && !isGenerating && (
        <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'grey.50' }}>
          <Typography variant="body1" color="text.secondary">
            No story generated yet. Click the button above to create your first Advenchore story!
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default AdvenchoreStoryPage;